export class ActivateGoogleWorkspaceResponse {
    'googleWorkspace';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "googleWorkspace",
            "baseName": "googleWorkspace",
            "type": "GoogleWorkspace",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ActivateGoogleWorkspaceResponse.attributeTypeMap;
    }
    constructor() {
    }
}
